export default __webpack_public_path__ + "static/media/eye-gestalt2.c2173be8.svg";